import React from 'react';
import { I18NContext } from '../../I18NContext';
import CancelFormV2 from './CancelFormV2';
import { CancelBottomSheetDetails, OrderSummaryPageLabels, CancellationResult } from '../component';
import "./Common.css";
import ErrorBoundary from '../../ErrorBoundary';

interface CancelV2Props {
    orderSummaryPageLabels: OrderSummaryPageLabels;
    cancelDetails: CancelBottomSheetDetails;
    refresh?: () => void;
    isPillPack?: boolean;
    onCancellationComplete?: (result: CancellationResult) => void;
}

interface CancelV2State {
    button: React.RefObject<any>;
    bottomSheet: React.RefObject<any>;
    showCloseButton: boolean;
    isDropdownOpen: boolean;
    openCount: number;
}

class CancelV2 extends React.Component<CancelV2Props, CancelV2State> {
    static contextType = I18NContext;

    constructor(props: CancelV2Props) {
        super(props);
        this.state = {
            button: React.createRef(),
            bottomSheet: React.createRef(),
            showCloseButton: true,
            isDropdownOpen: false,
            openCount: 0
        }
    }

    _openBottomSheet = (e: React.MouseEvent) => {
        e.preventDefault();
        if (this.state.bottomSheet.current) {
            this.state.bottomSheet.current.show();
            this.setState((prev) => ({
                showCloseButton: true,
                openCount: prev.openCount + 1
            }));
        }
    }

    _handleCancellationComplete = (result: CancellationResult) => {
        if (this.state.bottomSheet.current) {
            this.state.bottomSheet.current.hide();
        }
        if (this.props.onCancellationComplete) {
            this.props.onCancellationComplete(result);
        }
    };

    toggleDropdown = (isOpen: boolean) => {
        this.setState({ 
            isDropdownOpen: isOpen,
            showCloseButton: !isOpen
        }, () => {
            this.updateCloseButtonVisibility();
        });
    }

    render() {
        const ingressText = this.props.isPillPack
            ? this.props.orderSummaryPageLabels.cancelForm.pillPackCancelIngress
            : this.props.orderSummaryPageLabels.cancelForm.cancelItemInThisOrder;

        return (
            <>
                <pui-stack
                    direction="vertical"
                    ref={this.state.button}
                    onClick={this._openBottomSheet}
                    class="clickable"
                >
                    <pui-stack-item-button buttonPadding="none">
                        <pui-text
                            input={ingressText}
                            textSize="medium"
                            color="black"
                            paddingTop="medium"
                            paddingBottom="medium"
                        />
                    </pui-stack-item-button>
                </pui-stack>
                <ErrorBoundary>
                    <pui-bottom-sheet
                        id="cancellation-modal"
                        data-csa-c-content-id="cancellation-modal"
                        data-csa-c-type="popup"
                        data-csa-c-slot-id="order-detail"
                        hideLink
                        ref={this.state.bottomSheet}
                    >
                        <CancelFormV2
                            key={`cancel-form-${this.state.openCount}`}
                            cancelDetails={this.props.cancelDetails}
                            orderSummaryPageLabels={this.props.orderSummaryPageLabels}
                            refresh={this.props.refresh}
                            onCancellationComplete={this._handleCancellationComplete}
                            toggleDropdown={this.toggleDropdown}
                            isPillPack={this.props.isPillPack}
                        />
                    </pui-bottom-sheet>
                </ErrorBoundary>
            </>
        )
    }

    componentDidUpdate(prevProps: CancelV2Props, prevState: CancelV2State) {
        if (this.state.showCloseButton !== prevState.showCloseButton || 
            this.state.isDropdownOpen !== prevState.isDropdownOpen) {
            this.updateCloseButtonVisibility();
        }
    }

    updateCloseButtonVisibility() {
        if (this.state.bottomSheet.current) {
            const shadowRoot = this.state.bottomSheet.current.shadowRoot;
            if (shadowRoot) {
                const closeButton = shadowRoot.querySelector('#pui-bottom-sheet-close-button');
                if (closeButton) {
                    if (this.state.showCloseButton) {
                        closeButton.classList.remove('pui-hidden');
                    } else {
                        closeButton.classList.add('pui-hidden');
                    }
                }
            }
        }
    }
}

export default CancelV2;
